import React from 'react';

import TextInput from 'kingpin/atoms/TextInput';
import {
  GadgetFormInner,
  GadgetFormInnerContent,
  GadgetFormWrapper,
} from 'components/V5GadgetForm/V5GadgetForm';
import Inputs from 'components/Inputs';

import { PaceMatrixFormTypes } from './types';
import GroupByInput from '../GroupByInput';
import Preview from './Preview';
import LabeledSection from './LabeledSection';
import SortOrderInput from './SortOrderInput';

const AGG_FUNC_GREEN_LIST: AggFunc[] = ['count', 'sum'];

const PaceMatrixForm = ({
  formState,
  isEditing,
  isLoading,
}: {
  formState: PaceMatrixFormTypes.FormState;
  isEditing: boolean;
  isLoading: boolean;
}) => (
  <GadgetFormWrapper>
    <GadgetFormInner isGadgetBuilder={false}>
      <GadgetFormInnerContent isGadgetBuilder={false}>
        <LabeledSection label={'Name'}>
          <TextInput
            value={formState.name}
            onChange={formState.onNameChanged}
            placeholder="Name"
            data-testid={'pace-name'}
          />
        </LabeledSection>
        <LabeledSection label={'Description'}>
          <TextInput
            value={formState.description}
            onChange={formState.onDescriptionChanged}
            placeholder="Description"
          />
        </LabeledSection>
        <LabeledSection label={'Metric'}>
          <Inputs.MetricPicker
            metricId={formState.metricId}
            setMetricId={formState.setMetricId}
            aggFuncGreenList={AGG_FUNC_GREEN_LIST}
          />
        </LabeledSection>
        <LabeledSection label={'Metric Display Name'}>
          <TextInput
            value={formState.metricDisplayName || ''}
            onChange={formState.onMetricDisplayNameChanged}
            placeholder="Metric Display Name"
          />
        </LabeledSection>
        <LabeledSection label={'Group By Field'}>
          <GroupByInput
            groupBy={formState.groupByField}
            setGroupBy={formState.setGroupByField}
          />
        </LabeledSection>
        <LabeledSection label={'Interval'}>
          <Inputs.Dropdown options={formState.intervalOptions} />
        </LabeledSection>
        <LabeledSection label={'Totals Column'}>
          <Inputs.Toggle
            value={formState.hasTotalsCol}
            onChange={formState.setHasTotalsCol}
            testId={'pace-totals-toggle'}
          />
        </LabeledSection>
        <LabeledSection label={'Pace Column'}>
          <Inputs.Toggle
            value={formState.hasPaceCol}
            onChange={formState.setHasPaceCol}
          />
        </LabeledSection>
        <LabeledSection label={'Pin Total/Pace Columns'}>
          <Inputs.Toggle
            value={formState.isTotalsAndPacePinnedRight}
            onChange={formState.setIsTotalsAndPacePinnedRight}
          />
        </LabeledSection>
        <LabeledSection label={'Only Show Total/Pace'}>
          <Inputs.Toggle
            value={formState.isShowingOnlyPaceCol}
            onChange={formState.setIsShowingOnlyPaceCol}
          />
        </LabeledSection>
        <LabeledSection label={'Card Mode'}>
          <Inputs.Toggle
            value={formState.isCardMode}
            onChange={formState.setIsCardMode}
          />
        </LabeledSection>
        <SortOrderInput
          isCardMode={formState.isCardMode}
          sortOrder={formState.sortOrder}
          setSortOrder={formState.setSortOrder}
        />
      </GadgetFormInnerContent>
    </GadgetFormInner>
    <Preview formState={formState} isGadgetBuilder={false} />
  </GadgetFormWrapper>
);

export default PaceMatrixForm;
